import { Box, CircularProgress } from "@mui/material";

export default function BoxLoading() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100%",
      }}
    >
      <CircularProgress color="info" />
    </Box>
  );
}
